import { render, staticRenderFns } from "./form-education.vue?vue&type=template&id=2ec44404&"
import script from "./form-education.vue?vue&type=script&lang=js&"
export * from "./form-education.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports